<template>
  <div class="page">
    <Header title="获奖记录" />
    <div class="record-tabs">
      <van-button type="default" class="record-tab" round :class="{ 'active': activeTab === 'cardsRecord' }"
        @click="handleTabChange('cardsRecord')">获取卡牌记录</van-button>
      <van-button type="default" class="record-tab" round :class="{ 'active': activeTab === 'awardRecord' }"
        @click="handleTabChange('awardRecord')">获奖记录</van-button>
    </div>
    <div class="record-cards">
      <!-- 获取卡牌记录 -->
      <template v-if="activeTab === 'cardsRecord'">
        <!-- 全部获得 -->
        <div class="group-box">
          <div class="group-title">
            <div class="title-icon"></div>全部获得
          </div>
          <div class="group-content">
            <div class="bosch-cards">
              <div :class="item.count === 0 ? 'no-card-drawn' : 'card-drawn'" v-for="item in collectPieceList"
                :key="item.text">
                <template v-if="item.count > 0">
                  <div class="card-num">{{ item.count }}</div>
                  <div class="card-text" v-if="item.count > 0">{{ item.pieceCode }}</div>
                </template>
              </div>
            </div>
            <div class="text-center">
              <div
              :class="[
                {'compose-active-button' : canCompose},
                {'compose-button':!canCompose},
                {'activity-expiration' : isActivityfinished}
              ]"
              @click="handleCompositeCards">合成卡牌
              </div>
            </div>
          </div>
        </div>
        <!-- 渠道来源 -->
        <div class="group-box">
          <div class="group-title">
            <div class="title-icon"></div>渠道来源
          </div>
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadCard" class="van-list">
            <div class="group-content" v-if="cardList.length">
              <div class="record-card" v-for="(item, index) in cardList" :key="index">
                <van-row :gutter="10">
                  <van-col :span="6" class="text-center">
                    <div class="card-drawn">
                      <div class="card-num">1</div>
                      <div class="card-text">{{ item.pieceCode }}</div>
                    </div>
                  </van-col>
                  <van-col :span="18">
                    <p class="record-card-text">博世卡牌"{{ item.pieceCode }}"</p>
                    <p class="record-card-text">
                      <span>获取渠道：</span>
                      <span v-if="item.remark === 'kz'">康众订单</span>
                      <span v-if="item.remark === 'cass'">开思订单</span>
                      <span v-if="item.remark === 'scan'">扫码</span>
                     </p>
                    <p class="record-card-text">获得时间：{{ item.collectTime | parseTime('{y}-{m}-{d} {h}:{i}') }}</p>
                  </van-col>
                </van-row>
              </div>
            </div>
          </van-list>

        </div>
      </template>
      <!-- 获奖记录 -->
      <template v-if="activeTab === 'awardRecord'">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadAward" class="van-list">
          <div class="record-award" v-if="awardList.length">
            <ActivityCollectCardsCoupon
              :award-list="awardList"
              :style-type="'small'"
              :height="'100px'"
              :showCount="false">
            </ActivityCollectCardsCoupon>
          </div>
        </van-list>
      </template>
    </div>
    <ActivityCollectCardsCompose ref="ActivityCollectCardsCompose" :list="composeList"></ActivityCollectCardsCompose>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
import ActivityCollectCardsCompose from './components/activity-collectCards-compose.vue'
import ActivityCollectCardsCoupon from './components/activity-collectCards-coupon.vue'
import Header from '@/components/header'
export default {
  components: {
    Header,
    ActivityCollectCardsCompose,
    ActivityCollectCardsCoupon
  },
  data () {
    return {
      activeTab: 'cardsRecord',
      cardList: [],
      awardList: [],
      collectPieceList: [],
      canCompose: false,
      pageInfo: {
        page: 1,
        pageSize: 10
      },
      loading: false,
      finished: false,
      composeList: [],
      isActivityfinished: false
    }
  },
  watch: {
    'collectPieceList': {
      immediate: true,
      handler (val) {
        let boschArr = ['B', 'O', 'S', 'C', 'H']
        this.canCompose = (() => {
          for (let i = 0; i < this.collectPieceList.length; i++) {
            if (boschArr.includes(this.collectPieceList[i].pieceCode)) {
              if (this.collectPieceList[i].count < 1) {
                return false
              }
            }
          }
          return true
        })()
      }
    }
  },
  computed: {
  },
  created () {
    this.getCardActivityInfo()
    const nowDate = new Date()
    // const nowDate = new Date('2023-06-16T23:59:59')
    const endDate = new Date('2023-06-15T23:59:59')
    if (nowDate - endDate > 0) {
      // 活动结束
      this.isActivityfinished = true
    } else {
      this.isActivityfinished = false
    }
  },
  methods: {
    getCardActivityInfo () {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      activityApi.getCardActivityInfo().then(res => {
        if (res.data.resultCode === '0') {
          this.collectPieceList = res.data.resultData.collectPieceList || []
        }
        this.$toast.clear()
      }).catch(() => {
        this.$toast.clear()
      })
    },
    handleTabChange (tabName) {
      if (this.activeTab !== tabName) {
        this.activeTab = tabName
        switch (this.activeTab) {
          case 'cardsRecord':
            this.awardList = []
            this.collectPieceList = []
            this.getCardActivityInfo()
            break
          case 'awardRecord':
            this.cardList = []
            break
          default:
            break
        }
        this.pageInfo.page = 1
        this.loading = false
        this.finished = false
      }
    },
    // 合成卡牌
    handleCompositeCards () {
      if (this.isActivityfinished) return
      if (!this.canCompose) return
      const counts = this.collectPieceList.map(item => {
        return item.count
      })
      let count = Math.min(...counts)
      if (count > 0) {
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true
        })
        const params = {
          count: count >= 10 ? 10 : count
        }
        activityApi.LotteryCards(params).then(res => {
          if (res.data.resultCode === '0') {
            const { prizeList } = res.data.resultData
            this.composeList = prizeList || []
            this.$refs['ActivityCollectCardsCompose'].open()
            this.getCardActivityInfo()
          }
          this.$toast.clear()
        }).catch(() => {
          this.$toast.clear()
        })
      } else { }
    },
    onLoadAward () {
      console.log('onLoad')
      const page = this.pageInfo.page
      let dataParams = {
        page: page,
        pageSize: this.pageInfo.pageSize
      }
      activityApi.getCardAwardList(dataParams).then(res => {
        if (res.data.resultCode === '0') {
          const { awardList, pageInfo } = res.data.resultData
          this.awardList = this.awardList.concat(awardList || [])
          this.loading = false
          this.pageInfo.page++
          if (this.pageInfo.page > pageInfo.totalPages) {
            this.finished = true
          }
        }
      })
    },
    onLoadCard () {
      const page = this.pageInfo.page
      let dataParams = {
        page: page,
        pageSize: this.pageInfo.pageSize
      }
      activityApi.getCardCardList(dataParams).then(res => {
        if (res.data.resultCode === '0') {
          const { cardList, pageInfo } = res.data.resultData
          this.cardList = this.cardList.concat(cardList || [])
          this.loading = false
          this.pageInfo.page++
          if (this.pageInfo.page > pageInfo.totalPages) {
            this.finished = true
          }
        }
      }).catch(() => {
      })
    },
    handleCouponBg (item) {
      if (item.itemCode === '0') {
        return 'collect-coupon-point'
      } else {
        if (item.couponDTO.couponStatus === '02') {
          return 'collect-coupon-gift'
        } else if (item.couponDTO.couponStatus === '03') {
          return 'collect-coupon-used'
        } else {
        }
      }
    }
  }
}
</script>
<style lang='less' scoped>
.page {
  // display: flex;
  // flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
}

.bosch-cards {
  margin: 0px;
  margin-bottom: 0px;
  // margin-top: 54px;
}

.record-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0;
  padding: 10px 0px;

  .record-tab {
    width: 48%;
  }

  .active {
    background-color: #5696A0;
    color: #fff;
  }
}

.record-cards {
  flex: auto;
  // margin: 10px;
  // padding: 15px;
  overflow: hidden;
  // overflow-x: hidden;
  // overflow-y: auto;

  .record-card {
    +.record-card {
      margin: 10px 0px;

    }
  }

  .record-card-text {
    font-size: 12px;
    padding: 8px 0px;

  }

  .record-award {
    margin-bottom: 10px;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
  }
}

.group-box {
  margin-bottom: 10px;
  background-color: #fff;
  border-radius: 10px;
  padding-bottom: 5px;

  .group-title {
    padding: 15px 0px;
    font-size: 16px;
    display: flex;
    align-items: center;

    .title-icon {
      width: 2px;
      height: 16px;
      background: #D8D8D8;
      border-radius: 0px 2px 2px 0px;
      border: 1px solid #5696A0;
      background-color: #5696A0;
      display: inline-block;
      margin-right: 10px;
    }
  }

  .group-content {
    background-color: #fff;
    padding: 15px;
    padding-top: 0px;
    overflow-x: hidden;
    overflow-y: auto;
  }

}

.van-list {
  height: calc(100vh - 110px);
  width: 100%;
  overflow: auto;
}
.activity-expiration{
  filter: grayscale(100%);
}
</style>
